import {Component, OnInit} from '@angular/core';
import {ModalKendo} from "../../lib/ModalKendo";
import {FiadosService} from "../../services/fiados.service";
import {FiadoFormaPagamentoUtils} from "../fiado-forma-pagamento.utils";

@Component({
  selector: 'app-modal-credito-fiado',
  templateUrl: './modal-credito-fiado.component.html',
  styleUrls: ['./modal-credito-fiado.component.scss']
})
export class ModalCreditoFiadoComponent extends ModalKendo implements OnInit {
  contato: any;
  private _formasDePagamento: any[] = [];
  get formasDePagamento() {
    return this._formasDePagamento;
  }
  set formasDePagamento(formas: any[]) {
    this._formasDePagamento = (formas || [])
      .filter((forma: any) => this.formaPermitida(forma));
    this.garantaFormaDePagamentoSelecionada();
  }
  carregando = false;
  erro = '';
  dados: any = {
    idContato: null,
    idFormaDePagamento: null,
    valor: 0,
    observacao: ''
  };

  constructor(private fiadosService: FiadosService) {
    super();
  }

  ngOnInit(): void {
    this.dados.idContato = this.contato?.id;

    this.garantaFormaDePagamentoSelecionada();
  }

  private garantaFormaDePagamentoSelecionada() {
    const formaSelecionadaPermitida = this._formasDePagamento
      .some((forma: any) => forma.id === this.dados.idFormaDePagamento);

    if(!formaSelecionadaPermitida)
      this.dados.idFormaDePagamento = this._formasDePagamento.length ? this._formasDePagamento[0].id : null;
  }

  formaPermitida(forma: any) {
    return FiadoFormaPagamentoUtils.formaPermitidaParaRecebimento(forma);
  }

  selecioneFormaDePagamento(forma: any) {
    this.dados.idFormaDePagamento = forma?.id || null;
  }

  formaSelecionada(forma: any) {
    return !!forma && this.dados.idFormaDePagamento === forma.id;
  }

  obtenhaTituloFormaPagamento(forma: any) {
    return forma?.descricao || forma?.nome ;
  }

  obtenhaDescricaoFormaPagamento(forma: any) {
    const nome = String(forma?.nome || forma?.descricao || '').toLowerCase();

    if(nome.includes('pix') && nome.includes('chave')) return 'Pagamento via chave PIX';
    if(nome.includes('pix')) return 'Pagamento instantaneo';
    if(nome.includes('dinheiro')) return 'Pagamento em especie';
    if(nome.includes('credito')) return 'Credito a vista ou parcelado';
    if(nome.includes('debito')) return 'Debito a vista';
    if(nome.includes('vale') || nome.includes('voucher')) return 'Vale, troco ou outro meio';

    return forma?.nome || 'Pagamento offline';
  }

  obtenhaIconeFormaPagamento(forma: any) {
    const nome = String(forma?.nome || forma?.descricao || '').toLowerCase();

    if(nome.includes('pix') && nome.includes('chave')) return 'fa-key';
    if(nome.includes('pix')) return 'fa-qrcode';
    if(nome.includes('dinheiro')) return 'fa-money-bill-wave';
    if(nome.includes('credito') || nome.includes('debito')) return 'fa-credit-card';
    if(nome.includes('vale') || nome.includes('voucher')) return 'fa-ticket-alt';

    return 'fa-wallet';
  }

  obtenhaCorFormaPagamento(forma: any) {
    const nome = String(forma?.nome || forma?.descricao || '').toLowerCase();

    if(nome.includes('pix') && nome.includes('chave')) return 'teal';
    if(nome.includes('pix')) return 'purple';
    if(nome.includes('dinheiro')) return 'green';
    if(nome.includes('credito')) return 'violet';
    if(nome.includes('debito')) return 'blue';
    if(nome.includes('vale') || nome.includes('voucher')) return 'orange';

    return 'gray';
  }

  onSubmit() {
    this.erro = '';

    if(!(Number(this.dados.valor) > 0)) {
      this.erro = 'Informe um valor válido para o crédito.';
      return;
    }

    if(!this.dados.idFormaDePagamento) {
      this.erro = 'Selecione a forma de pagamento.';
      return;
    }

    this.carregando = true;
    this.fiadosService.adicioneCredito({
      idContato: this.dados.idContato,
      idFormaDePagamento: this.dados.idFormaDePagamento,
      valor: Number(this.dados.valor),
      observacao: this.dados.observacao
    }).then((resposta: any) => {
      this.carregando = false;
      this.fecheModal(resposta);
    }).catch((erro: any) => {
      this.carregando = false;
      this.erro = erro;
    });
  }
}
